;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import svg from "../assets/coachesIcon.svg"
import SvgAsset from "./SvgAsset"

function CoachesIcon({ color }) {
  return (
    <SvgAsset
      svg={svg}
      viewBox="0 0 42 47"
      width="45px"
      height="45px"
      color={color ? color : "#AAAAAA"}
    />
  )
}
export default CoachesIcon
